import React from 'react';
import { Button, Form, Modal } from "react-bootstrap";

const DriversViewodal = ({ show, handleClose, isEdit }) => {
    const status = [{ title: 'Pending', id: 0 }, { title: 'Submitted', id: 1 }, { title: 'Reject', id: 2 }, { title: 'Approved', id: 3 }, { title: 'Revision', id: 4 }]
    const documentStatus = status.find((item) => item.id == isEdit.document_status)

    console.log(documentStatus)
    return (
        <>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5 text-center">View Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* Render row details */}
                    <div className="row">
                        <div className="col-md-12 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Full Name:</span>
                            <p>{isEdit?.full_name}</p> {/* Replace with dynamic data */}
                        </div>
                        <div className="col-md-12 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Email Address:</span>
                            <p>{isEdit?.email}</p> {/* Replace with dynamic data */}
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Phone Number</span>
                            <p>{isEdit?.phone}</p> {/* Replace with dynamic data */}
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Date of Birth</span>
                            <p>{isEdit?.dob}</p> {/* Replace with dynamic data */}
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Employment Status</span>
                            <p><span className='badge bg-info'> {isEdit?.employment_status == 1 ? 'Active' : 'DeActive'}</span></p> {/* Replace with dynamic data */}
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Document Status</span>
                            <p><span className='badge bg-info'> {documentStatus?.title} </span></p> {/* Replace with dynamic data */}
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Created At</span>
                            <p><span className='badge bg-info'> {isEdit?.created_at}</span></p> {/* Replace with dynamic data */}
                        </div>
                        <div className="col-md-6 mb-2">
                            <span style={{ fontWeight: 'bold' }}>Updated At</span>
                            <p><span className='badge bg-info'> {isEdit?.updated_at}</span></p> {/* Replace with dynamic data */}
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer className="border-0">
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default DriversViewodal;